const CopyRight: React.FC = () => {
  return (
    <label className="text-sm">
      © 2024 Expertstack Pty Ltd | All Rights Reserved.
    </label>
  );
};

export default CopyRight;
